/* eslint-disable no-unused-vars */
import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {

    interface Palette {
        brown: string;
        lightBrown: string;
        darksalmon: string;
        lightsalmon: string;
        vine: string;
        lightVine: string;
        dark: string;
        light: string;
        lightdark: string;
    }
    
    interface PaletteOptions {
        brown: string;
        lightBrown: string;
        darksalmon: string;
        lightsalmon: string;
        vine: string;
        lightVine: string;
        dark: string;
        light: string;
        lightdark: string;
    }
}

declare module '@mui/material/styles/createTypography' {
    interface FontStyle {
        fontNunito: string;
        fontWeightSemiBold: number;
    }
}

const theme = createTheme({
    typography: {
        fontFamily: ['Poppins', 'sans-serif'].toString(),
        fontWeightSemiBold: 400,
    },
    components: {
        MuiButton: {
            defaultProps: {
                sx: {
                    '&.MuiButton.outlined.primary': {
                        backgroundColor: ({ palette }) => palette.common.white,
                        borderColor: ({ palette }) => palette.darksalmon,
                        color: ({ palette }) => palette.darksalmon,
                        pl: '32px',
                        pr: '32px',
                    },
                }
            },
            styleOverrides: {
                root: {
                    borderRadius: 100,
                    textTransform: 'initial',
                    height: 'fit-content !important',
                },
            },
        },
        MuiButtonBase: {
            defaultProps: {
                sx: {
                    '&.MuiButton.outlined.primary': {
                        backgroundColor: ({ palette }) => palette.common.white,
                        borderColor: ({ palette }) => palette.darksalmon,
                        color: ({ palette }) => palette.darksalmon,
                        pl: '32px',
                        pr: '32px',
                    },
                    '&.MuiButton.contained.primary': {
                        backgroundColor: ({ palette }) => palette.darksalmon,
                        borderColor: ({ palette }) => palette.darksalmon,
                        color: ({ palette }) => palette.common.white,
                        pl: '32px',
                        pr: '32px',
                    },
                }
            }
        },
        MuiOutlinedInput: {
            defaultProps: {
                // size: 'medium',
                sx: {
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderWidth: '.0625rem',
                        borderColor: ({ palette }) => 'red',
                    },
                    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                        borderColor: ({ palette }) => 'green',
                    },
                    ...{
                        color: ({ palette }) => palette.dark,
                        fontWeight: ({ typography }) => typography.fontWeightMedium,
                        backgroundColor: ({ palette }) => palette.common.white,
                    },
                },
            },
        },
    },
    palette: {
        brown: '#3D251E',
        lightBrown: '#A08679',
        darksalmon: '#D89274',
        lightsalmon: '#FFF6F2',
        vine: '#331A1E',
        lightVine: '#887376',
        dark: '#010101',
        light: '#FFFFFF',
        lightdark: '#353B48',
    },
});

export { theme };
